import { IEmailFormControlOptions } from "../email-form-control";
import { _SSControlOptionsBase } from "./types/_ss-control-options-base";
import { FormControlOptionsUtils } from "./utils/form-control-options-utils";

export class SSEmailOptions implements _SSControlOptionsBase<'email'> {

  constructor(
    private _initialOptions?: IEmailFormControlOptions
  ) {

    this._initOptions()
  }

  private _initOptions() {

    FormControlOptionsUtils.initMappedObject<'email'>(this, this._initialOptions);
  }

  dispose() {

  }
}
